import { getSettings } from "@insite/client-framework/Services/SettingsService";
import Cookies from "js-cookie";

let resolvedCookieDomain: string | undefined;

if (typeof window !== "undefined") {
    getSettings({})
        .then(settings => {
            const cookieDomain = settings?.properties?.cookieDomain;
            if (typeof cookieDomain === "string" && cookieDomain) {
                resolvedCookieDomain = cookieDomain;
            }
        })
        .catch(() => {
            // keep using defaultDomain if the settings request fails
        });
}

const originalWithConverter = (Cookies.withConverter as Function).bind(Cookies);

(Cookies as any).withConverter = (converter: any) => {
    const instance = originalWithConverter(converter);
    const originalSet = instance.set.bind(instance);

    instance.set = (name: string, value: string, options?: any) => {
        options = options || {};
        if (!options.domain && resolvedCookieDomain) {
            options.domain = resolvedCookieDomain;
        }
        return originalSet(name, value, options);
    };

    return instance;
};

const cookiesToClean = [
    "CurrentLanguageId",
    "CurrentCurrencyId",
    "SetContextLanguageCode",
    "SetContextPersonaIds",
    "CurrentBillToId",
    "CurrentShipToId",
    "CurrentFulfillmentMethod",
    "CurrentPickUpWarehouseId",
    "BillToIdShipToId",
    "InsiteCacheId",
    "WC_Roles",
    "WCSubdomain",
    "PunchOutSessionId"
];
// if (typeof window !== "undefined" && typeof document !== "undefined") {
// cookiesToClean.forEach(name => {
//     // Only delete if it exists without the correct domain
//     // (i.e. scoped to current hostname, not .whitecap.com)
//     const value = document.cookie
//         .split("; ")
//         .find(row => row.startsWith(`${name}=`))
//         ?.split("=")[1];

//     if (value) {
//         // Expire it on the current hostname (no domain = current host)
//         document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
//     }
// })
// }